(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ps-build-3step"] && !Shopify.designMode) return;
  try {
    (() => {
  const VIP_PROPERTY_NAME = 'Dental VIP Access';
  const VIP_PROPERTY_VALUE = 'Yes - Free 30 days, then $20/mo';
  if (customElements.get('puur-b3-build')) return;

  class PuurB3Build extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const boot = () => {
        if (!this.querySelector('[data-b3-labels]')) return;
        this.observer?.disconnect();
        this.init();
      };
      if (this.querySelector('[data-b3-labels]')) boot();
      else {
        this.observer = new MutationObserver(boot);
        this.observer.observe(this, { childList: true, subtree: true });
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.formObserver?.disconnect();
      this.releaseNativeForm();
      this.swap?.remove();
      this.swapNote?.remove();
      this.swap = null;
      this.controller = null;
    }

    init() {
      this.labels = JSON.parse(this.querySelector('[data-b3-labels]').dataset.config);
      this.money = new Intl.NumberFormat(this.labels.locale, { style: 'currency', currency: this.labels.currency });
      this.busy = false;
      this.uncertain = false;

      this.cards = Array.from(this.querySelectorAll('[data-b3-card]')).map(el => ({
        el,
        kind: el.dataset.kind,
        config: JSON.parse(el.querySelector('[data-b3-config]').dataset.config),
        choice: el.querySelector('[data-b3-choice]'),
        vip: el.querySelector('[data-b3-vip]')
      }));

      // Step 2 is a single choice, so exactly one of the two cards is always
      // selected. Basic Starter is the default and the fallback if the upgrade
      // cannot be sold.
      this.basic = this.cards.find(c => c.kind === 'basic');
      this.breath = this.cards.find(c => c.kind === 'breath');
      this.vipCard = this.cards.find(c => c.kind === 'vip');
      this.pick = this.breath && this.breath.choice?.checked ? this.breath : this.basic;

      // A locked VIP card is settled elsewhere: already held, or already its own
      // line in the cart. It shows as taken and is kept out of both the total
      // and the cart payload, because adding it again enrols one person twice.
      if (this.vipCard?.el.querySelector('[data-b3-vip-enrolled]')) {
        this.vipCard.locked = 'member';
        this.vipCard.selected = true;
      }

      this.addEventListener('change', event => {
        if (this.busy) return;
        if (event.target.matches('[data-b3-choice]')) {
          const card = this.cards.find(c => c.choice === event.target);
          if (card && this.offer(card).valid) this.pick = card;
          else if (this.basic) { this.pick = this.basic; if (this.basic.choice) this.basic.choice.checked = true; }
          this.paint();
        }
        if (event.target.matches('[data-b3-vip]')) {
          this.vipCard.selected = event.target.checked;
          this.paint();
        }
      }, { signal: this.controller.signal });

      this.addEventListener('shopify:block:select', event => {
        const card = this.cards.find(c => c.el.dataset.blockId === event.detail.blockId);
        if (card && card.choice && this.offer(card).valid) { card.choice.checked = true; this.pick = card; this.paint(); }
      }, { signal: this.controller.signal });

      this.mainProduct = this.closest('.product-section[data-section-type="product"]');
      if (this.mainProduct) {
        this.bindNativeForm();
        for (const type of ['click', 'submit']) {
          this.mainProduct.addEventListener(type, event => this.handleNativeEvent(event), { capture: true, signal: this.controller.signal });
        }
        this.bindGallery();
        // The theme rebuilds the slideshow when an image set switches variant
        // group, which takes the layer with it; rebind rather than leave a
        // detached node behind.
        this.formObserver = new MutationObserver(() => { this.bindGallery(); if (this.bindNativeForm()) this.paint(); });
        this.formObserver.observe(this.mainProduct, { childList: true, subtree: true });
        document.addEventListener('variant:change', event => {
          const belongs = this.mainProduct.contains(event.target) ||
            String(event.detail?.sectionId) === this.mainProduct.dataset.sectionId;
          if (belongs) this.paint();
        }, { signal: this.controller.signal });
        this.mainProduct.addEventListener('change', event => {
          if (!this.contains(event.target)) this.paint();
        }, { signal: this.controller.signal });
      }

      this.guardMembership();
      this.paint();
    }

    /* ---------------- native form ---------------- */
    bindNativeForm() {
      const byId = document.getElementById(this.dataset.formId);
      const form = byId?.tagName === 'FORM' && this.mainProduct?.contains(byId) ? byId :
        this.mainProduct?.querySelector('form[action*="/cart/add"]');
      if (form === this.form && this.nativeButton?.isConnected) return false;
      this.releaseNativeForm();
      this.form = form || null;
      this.nativeButton = form?.querySelector('.payment-buttons button[name="add"][data-add-to-cart]') || null;
      if (!this.nativeButton) { this.form = null; return false; }
      this.nativeText = this.nativeButton.querySelector('[data-add-to-cart-text]') || this.nativeButton;
      this.originalNative = {
        text: this.nativeText.dataset.defaultText || this.nativeText.textContent,
        disabled: this.nativeButton.disabled,
        busy: this.nativeButton.getAttribute('aria-busy'),
        style: this.form.style.getPropertyValue('--b3-native-red')
      };
      this.form.classList.add('b3-native-form');
      this.form.style.setProperty('--b3-native-red', getComputedStyle(this).getPropertyValue('--red').trim() || '#C8102E');
      this.nativeButton.setAttribute('data-b3-native-add', '');
      this.wallets = Array.from(form.querySelectorAll('.payment-buttons .shopify-payment-button'));
      for (const note of form.querySelectorAll('.b3-native-wallet-note')) note.remove();
      this.walletNote = document.createElement('p');
      this.walletNote.className = 'b3-native-wallet-note';
      this.walletNote.textContent = 'Use Add to cart for your selected kit or membership. Shop Pay is available at checkout.';
      this.walletNote.hidden = true;
      this.walletNote.setAttribute('role', 'status');
      form.querySelector('.payment-buttons').append(this.walletNote);
      // Terms line, between Add to cart and the wallet button, where the design
      // puts it. It lives in the theme's form, not the builder, so it is
      // inserted here and taken out again in releaseNativeForm.
      for (const old of form.querySelectorAll('.b3-native-terms')) old.remove();
      this.termsNote = null;
      if (this.labels.atcNote) {
        this.termsNote = document.createElement('p');
        this.termsNote.className = 'b3-native-terms';
        this.termsNote.textContent = this.labels.atcNote;
        this.nativeButton.insertAdjacentElement('afterend', this.termsNote);
      }
      return true;
    }
    releaseNativeForm() {
      if (this.nativeButton && this.originalNative) {
        this.nativeText.textContent = this.originalNative.text;
        this.nativeButton.disabled = this.originalNative.disabled;
        if (this.originalNative.busy === null) this.nativeButton.removeAttribute('aria-busy');
        else this.nativeButton.setAttribute('aria-busy', this.originalNative.busy);
        this.nativeButton.removeAttribute('data-b3-native-add');
        this.form.classList.remove('b3-native-form');
        if (this.originalNative.style) this.form.style.setProperty('--b3-native-red', this.originalNative.style);
        else this.form.style.removeProperty('--b3-native-red');
      }
      for (const wallet of this.wallets || []) wallet.removeAttribute('data-b3-wallet-hidden');
      this.walletNote?.remove();
      this.termsNote?.remove();
      this.form = null;
      this.nativeButton = null;
      this.wallets = [];
    }
    nativeValues() {
      const value = name => this.form?.elements.namedItem(name)?.value || '';
      return { id: String(value('id')), quantity: Number(value('quantity') || 1), planId: String(value('selling_plan')) };
    }
    basePrice() {
      // The flosser's own price comes from the theme's variant data rather than
      // being restated here, so a price change on the product needs no edit.
      const node = this.mainProduct?.querySelector('[data-product-price] .money') ||
                   this.mainProduct?.querySelector('[data-product-price]');
      // First money-looking run only: the element can also carry a compare-at
      // price, and "$89.00$200.00" parses as a number that is not a price.
      const match = node && String(node.textContent).match(/\d[\d,]*(?:\.\d{1,2})?/);
      const parsed = match ? Number(match[0].replace(/,/g, '')) : NaN;
      return Number.isFinite(parsed) ? Math.round(parsed * 100) : 0;
    }
    // Something this page still has to ADD. A locked card is excluded: it is
    // already held or already a cart line, so the theme's own add-to-cart is
    // left to do its job.
    hasExtras() {
      return this.cards.some(c => c !== this.basic && !c.locked &&
        ((c.kind === 'breath' && this.pick === c) || (c.kind === 'vip' && c.selected)));
    }
    // Separate question: an accelerated checkout ignores the cart, so a
    // membership already sitting in it would be dropped on the way to a wallet.
    cartHoldsMembership() {
      return this.cards.some(c => c.locked === 'cart');
    }
    handleNativeEvent(event) {
      if (!this.form) return;
      // ---- accelerated checkout ----------------------------------------
      // Shop Pay, PayPal, Apple Pay and G Pay check out the FORM, not the cart,
      // and a dynamic checkout form carries exactly one variant. So a shopper
      // who picked a kit or the membership and then tapped a wallet bought the
      // flosser on its own and lost the rest.
      //
      // The wallet lives in a closed shadow root, so its own handler cannot be
      // reached — but the click is retargeted to the host on the way down, and
      // this listener is already on the capture phase above it. Stopping it
      // here runs before anything inside the shadow root sees it.
      //
      // What replaces it: put everything in the cart, then hand the shopper to
      // checkout, where the same wallets are offered against the full cart.
      // They lose one tap and keep the order they actually built.
      if (event.type === 'click') {
        const wallet = event.target.closest?.(
          '.shopify-payment-button, shopify-accelerated-checkout, shopify-accelerated-checkout-cart, shopify-buy-it-now-button');
        if (wallet && this.form.contains(wallet)) {
          // Nothing of ours to carry: let the wallet do its normal job.
          if (!this.hasExtras() && !this.cartHoldsMembership() && !this.busy && !this.uncertain) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          if (this.busy || this.uncertain || !this.form.reportValidity()) return;
          this.addToCart({ express: true });
          return;
        }
      }
      const button = event.target.closest?.('button[name="add"][data-add-to-cart]');
      if (event.type === 'click' && button !== this.nativeButton) return;
      if (event.type === 'submit' && event.target !== this.form) return;
      if (!this.hasExtras() && !this.busy && !this.uncertain) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.busy || this.uncertain || !this.form.reportValidity()) return;
      this.addToCart();
    }

    /* ---------------- pricing ---------------- */
    offer(card) {
      if (!card) return { valid: false, price: 0 };
      if (card.kind === 'basic') return { valid: true, price: 0 };
      const c = card.config;
      const plan = card.kind === 'vip'
        ? (c.plans || []).find(p => p.recurring && (!c.sellingPlanId || String(p.id) === String(c.sellingPlanId))) ||
          (c.plans || []).find(p => p.recurring)
        : null;
      const needsPlan = card.kind === 'vip';
      const valid = Boolean(c.variantId && c.available && !c.invalidVariant && (!needsPlan || plan));
      return { valid, plan, price: plan ? plan.price : c.price };
    }

    paint() {
      if (!this.cards) return;

      // If the upgrade cannot be sold, the choice falls back to the starter
      // rather than leaving the shopper on a card that cannot be bought.
      if (this.pick === this.breath && !this.offer(this.breath).valid) {
        this.pick = this.basic;
        if (this.basic?.choice) this.basic.choice.checked = true;
      }

      const base = this.basePrice();
      const upgrade = this.pick === this.breath ? this.offer(this.breath) : { price: 0 };
      const vipOffer = this.vipCard ? this.offer(this.vipCard) : null;
      const vipOn = Boolean(this.vipCard?.selected && !this.vipCard.locked && vipOffer?.valid);
      const total = base + (upgrade.price || 0) + (vipOn ? vipOffer.price : 0);

      // ---- the two cards
      for (const card of [this.basic, this.breath]) {
        if (!card) continue;
        const offer = this.offer(card);
        const picked = this.pick === card;
        card.el.classList.toggle('on', picked);
        card.el.classList.toggle('unavailable', !offer.valid);
        if (card.choice) { card.choice.checked = picked; card.choice.disabled = this.busy || !offer.valid; }
        const cta = card.el.querySelector('[data-b3-cta]');
        if (cta) cta.textContent = !offer.valid ? this.labels.unavailable
          : picked ? card.config.selectedLabel : card.config.chooseLabel;
        const price = card.el.querySelector('[data-b3-price]');
        if (price) {
          const prefix = price.dataset.prefix;
          const joined = prefix ? (/[A-Za-z]$/.test(prefix) ? `${prefix} ` : prefix) + card.config.money
            : card.config.money;
          price.textContent = !offer.valid ? this.labels.unavailable : joined;
        }
        // "$109.99 total today" — secondary to the incremental price, which is
        // the decision the brief wants the shopper making.
        const note = card.el.querySelector('[data-b3-total-note]');
        if (note) note.textContent = offer.valid && this.labels.totalNote
          ? `${this.money.format((base + offer.price) / 100)} ${this.labels.totalNote}` : '';
      }

      // ---- step 2 header
      const upgraded = Boolean(this.breath && this.pick === this.breath);
      // Tokens let the wording live in the theme editor while the names and
      // prices still come from the cards and the real variant.
      const fill = text => String(text || '')
        .replace(/\[basic\]/g, this.basic?.config.title || '')
        .replace(/\[upgrade\]/g, this.breath?.config.title || '')
        .replace(/\[price\]/g, this.money.format((upgrade.price || 0) / 100))
        .replace(/\[total\]/g, this.money.format(total / 100));
      const state = this.querySelector('[data-b3-kit-state]');
      if (state) {
        const wording = upgraded ? this.labels.kitStateUpgrade : this.labels.kitStateBasic;
        state.textContent = wording ? fill(wording) : (this.pick ? this.pick.config.title : '');
      }
      const kitTag = this.querySelector('[data-b3-kit-tag]');
      if (kitTag) {
        kitTag.textContent = upgraded ? `+${this.money.format(upgrade.price / 100)}` : this.labels.includedWord;
        kitTag.className = upgraded ? 'r' : 'g';
      }
      const kitCompare = this.querySelector('[data-b3-kit-compare]');
      if (kitCompare) {
        kitCompare.textContent = upgraded ? (this.breath.config.compareLabel || '') : '';
        kitCompare.hidden = !kitCompare.textContent;
      }
      const kitNote = this.querySelector('[data-b3-kit-note]');
      if (kitNote) {
        kitNote.textContent = upgraded && this.labels.kitNote ? fill(this.labels.kitNote) : '';
        kitNote.hidden = !kitNote.textContent;
      }

      // ---- step 3
      if (this.vipCard) {
        const settled = Boolean(this.vipCard.locked);
        const shown = settled ? true : vipOn;
        this.vipCard.el.classList.toggle('on', shown);
        this.vipCard.el.querySelector('[data-b3-vip-check]')?.classList.toggle('done', shown);
        const toggle = this.vipCard.el.querySelector('[data-b3-toggle]');
        toggle?.classList.toggle('on', shown);
        if (this.vipCard.vip) {
          this.vipCard.vip.disabled = this.busy || !this.form || !vipOffer.valid || settled;
          this.vipCard.vip.checked = Boolean(this.vipCard.selected);
        }
        const label = this.vipCard.el.querySelector('[data-b3-vip-label]');
        if (label) label.textContent = this.vipCard.selected ? `✓ ${this.vipCard.config.selectedLabel}` : this.vipCard.config.optIn;
        const sub = this.vipCard.el.querySelector('[data-b3-vip-sub]');
        if (sub) sub.textContent = this.vipCard.selected ? this.vipCard.config.selectedLabel : this.vipCard.config.subtitle;
      }

      // ---- summary: exactly what was selected, in order
      const lines = this.querySelector('[data-b3-lines]');
      lines.replaceChildren();
      const row = (label, value, cls) => {
        const p = document.createElement('p');
        p.className = 'b3-sline' + (cls === 'muted' ? ' muted' : '');
        const a = document.createElement('span'); a.textContent = label;
        const b = document.createElement('b'); b.textContent = value;
        if (cls === 'g') b.className = 'g';
        p.append(a, b); lines.append(p);
      };
      const baseLabel = this.querySelector('[data-b3-base-label]')?.textContent?.trim();
      row(baseLabel || this.mainProduct?.dataset.productTitle || 'Water Flosser', this.money.format(base / 100));
      if (this.basic) row(this.basic.config.summaryLabel, this.labels.includedWord, 'g');
      if (this.breath) {
        if (this.pick === this.breath) row(this.breath.config.summaryLabel, `+${this.money.format(upgrade.price / 100)}`);
        else row(this.breath.config.summaryLabel, this.labels.notSelected, 'muted');
      }
      if (this.vipCard) {
        if (this.vipCard.locked) row(this.vipCard.config.summaryLabel, this.vipCard.config.selectedLabel, 'g');
        else if (vipOn) row(this.vipCard.config.summaryLabel,
          vipOffer.price === 0 && this.vipCard.config.priceLabel ? this.vipCard.config.priceLabel
            : vipOffer.plan ? vipOffer.plan.money : this.vipCard.config.money,
          vipOffer.price === 0 ? 'g' : undefined);
        else row(this.vipCard.config.summaryLabel, this.labels.notSelected, 'muted');
      }
      this.querySelector('[data-b3-today]').textContent = this.money.format(total / 100);

      // ---- recurring vs one-time, stated separately
      const renew = this.querySelector('[data-b3-renew]');
      renew.replaceChildren();
      // The starter's replenishment is the standing recurring term on this
      // offer, so it is stated every time rather than only when something else
      // happens to renew.
      if (this.labels.renewsNote) {
        const p = document.createElement('p');
        const strong = document.createElement('strong');
        strong.textContent = 'Renews: ';
        p.append(strong, this.labels.renewsNote);
        renew.append(p);
      }
      if (vipOn && (this.vipCard.config.renewal || vipOffer.plan)) {
        const p = document.createElement('p');
        const strong = document.createElement('strong');
        strong.textContent = `${this.vipCard.config.summaryLabel}: `;
        p.append(strong, this.vipCard.config.renewal || vipOffer.plan.name);
        renew.append(p);
      }
      if (this.pick === this.breath && this.labels.oneTimeNote) {
        const p = document.createElement('p');
        const strong = document.createElement('strong');
        strong.textContent = `${this.breath.config.summaryLabel}: `;
        p.append(strong, this.labels.oneTimeNote);
        renew.append(p);
      }
      renew.hidden = !renew.childElementCount;

      this.paintGallery();
      this.total = total;
      this.paintNativeButton(total);
      this.dispatchEvent(new CustomEvent('b3-build:change', { bubbles: true, detail: {
        sectionId: this.dataset.sectionId, total, currency: this.labels.currency,
        kit: this.pick ? this.pick.kind : null, vip: vipOn
      } }));
    }

    paintNativeButton(total) {
      if (!this.nativeButton) return;
      this.nativeButton.disabled = this.busy || this.uncertain;
      this.nativeText.textContent = this.busy ? this.labels.loading : `${this.labels.atc} — ${this.money.format(total / 100)}`;
      this.nativeButton.setAttribute('aria-busy', String(this.busy));
      // See the note on the 4-step builder: wallet visibility with extras
      // selected is a setting, because an accelerated checkout ignores the cart.
      // Wallets no longer need hiding: a wallet click is intercepted above and
      // routed through the cart, so it can no longer lose a kit or the
      // membership. The setting stays for a merchant who wants them gone anyway.
      const noWallets = this.labels.hideWallets === true && (this.hasExtras() || this.cartHoldsMembership());
      for (const wallet of this.wallets) wallet.toggleAttribute('data-b3-wallet-hidden', noWallets || this.busy || this.uncertain);
      this.walletNote.hidden = !noWallets;
    }

    /* ------------------------------------------------------------------
       Gallery

       Step 2 always has exactly one option chosen, so the gallery always has
       something to show: the composed shot for whichever kit is selected,
       with a caption naming it.

       Drawn as a layer over the slideshow rather than pushed in as a real
       slide. The kit shots are theme files, not product media, so a slide
       would have no thumbnail to pair with — and the theme drives the
       thumbnails as Flickity's childNav, where an unpaired cell puts the two
       out of step for every image after it. A layer needs nothing from
       Flickity and hands the gallery back untouched.
    ------------------------------------------------------------------ */
    bindGallery() {
      if (this.swap && this.swap.isConnected) return;
      const group = this.mainProduct && this.mainProduct.querySelector('[data-product-single-media-group]');
      if (!group) return;
      if (getComputedStyle(group).position === 'static') group.style.position = 'relative';

      const swap = document.createElement('div');
      swap.className = 'b3-gallery-swap';
      group.append(swap);

      // QA removed the caption: on mobile it cost a line under the gallery and
      // pushed the title down. The element is still built, but never inserted,
      // so the swap logic below needs no special-casing.
      const note = document.createElement('p');
      note.className = 'b3-gallery-note';
      note.hidden = true;
      // Caption only. The shopper returns to the product photos by tapping the
      // gallery or a thumbnail, both still wired below.
      const label = document.createElement('span');
      note.append(label);
      // Under the whole media column, where the reference puts it — not inside
      // the stage, which would cover the photo it is describing.

      this.swap = swap;
      this.swapNote = note;
      this.swapLabel = label;

      swap.addEventListener('click', () => this.dismissGallery(), { signal: this.controller.signal });
      const thumbs = this.mainProduct.querySelector('[data-product-thumbs]');
      if (thumbs) thumbs.addEventListener('click', () => this.dismissGallery(), { signal: this.controller.signal });
    }
    // Reaching for the gallery means they want the product photos. Remembered
    // against the kit that was showing, so it stays put afterwards while
    // switching kit still brings the new one up.
    dismissGallery() {
      this.swapDismissedFor = this.swapShownFor;
      this.hideGallery();
    }
    hideGallery() {
      if (!this.swap) return;
      this.swap.classList.remove('b3-swap-in');
      this.swapNote.hidden = true;
      this.swapShownFor = null;
    }
    paintGallery() {
      if (!this.swap) return;
      const card = this.pick;
      if (!card) { this.hideGallery(); return; }
      const id = card.el.dataset.blockId;
      if (id === this.swapDismissedFor) { this.swapNote.hidden = true; return; }
      const template = card.el.querySelector('[data-b3-gallery]');
      if (!template) { this.hideGallery(); return; }
      if (this.swapShownFor !== id) {
        for (const previous of Array.from(this.swap.querySelectorAll('img'))) previous.remove();
        const image = template.content.cloneNode(true);
        // Eager: it is about to be the largest thing on screen, and a lazy
        // image swapped in on click arrives blank.
        for (const img of image.querySelectorAll('img')) img.loading = 'eager';
        this.swap.append(image);
        this.swapLabel.textContent = `${this.labels.showingPrefix} ${card.config.galleryCaption}`;
        this.swapShownFor = id;
      }
      this.swap.classList.add('b3-swap-in');
      this.swapNote.hidden = false;
    }

    /* ---------------- membership guard ---------------- */
    async guardMembership() {
      const card = this.vipCard;
      if (!card || card.locked) return;
      const ids = this.labels.membershipIds || [];
      if (!ids.length) return;
      let cart;
      try {
        const response = await fetch(`${this.dataset.cartUrl}.js`, {
          credentials: 'same-origin', headers: { Accept: 'application/json' }
        });
        if (!response.ok) return;
        cart = await response.json();
      } catch (_) { return; }
      const held = (cart.items || []).some(item => ids.some(id => String(item.product_id) === String(id)));
      if (!held) return;
      card.locked = 'cart';
      // Ticked, because it is true: the membership is in the cart and is being
      // bought. An empty greyed box beside "already in your cart" reads as
      // unavailable rather than secured.
      card.selected = true;
      const note = card.el.querySelector('[data-b3-vip-held]');
      if (note) {
        const mark = document.createElement('span');
        mark.setAttribute('aria-hidden', 'true');
        mark.textContent = '✓';
        const text = document.createElement('span');
        text.textContent = 'Dental VIP Access is already in your cart — it will not be added twice.';
        note.replaceChildren(mark, text);
        note.hidden = false;
      }
      this.paint();
    }

    /* ---------------- cart ---------------- */
    async addToCart({ express = false } = {}) {
      if (this.busy || this.uncertain || !this.form) return;
      const formData = new FormData(this.form);
      const native = this.nativeValues();
      if (!native.id) { this.paint(); return; }

      const base = { id: Number(native.id), quantity: Number.isSafeInteger(native.quantity) && native.quantity > 0 ? native.quantity : 1 };
      const baseProperties = {};
      for (const [key, value] of formData.entries()) {
        const property = key.match(/^properties\[(.+)\]$/);
        if (property && typeof value === 'string') baseProperties[property[1]] = value;
      }
      if (Object.keys(baseProperties).length) base.properties = baseProperties;
      if (native.planId) base.selling_plan = Number(native.planId);
      const items = [base];

      if (this.pick === this.breath) {
        const offer = this.offer(this.breath);
        if (!offer.valid) { this.paint(); return; }
        items.push({ id: Number(this.breath.config.variantId), quantity: 1 });
      }
      if (this.vipCard?.selected && !this.vipCard.locked) {
        const offer = this.offer(this.vipCard);
        if (!offer.valid) { this.paint(); return; }
        const item = { id: Number(this.vipCard.config.variantId), quantity: 1, properties: { [VIP_PROPERTY_NAME]: VIP_PROPERTY_VALUE } };
        // Same stamps as the dialcare card: the host product lets
        // dental-cart-guard remove the membership if the flosser leaves the
        // cart, and a Group 1 page declares its group or the member is
        // enrolled, and billed, as Group 2.
        if (this.dataset.productId) item.properties._dental_host_product = String(this.dataset.productId);
        if (this.labels.dentalGroup) item.properties._dental_group = this.labels.dentalGroup;
        if (offer.plan) item.selling_plan = Number(offer.plan.id);
        items.push(item);
      }

      let destination = this.dataset.cartUrl;
      const returnTo = formData.get('return_to');
      if (typeof returnTo === 'string' && returnTo) {
        try { const url = new URL(returnTo, window.location.origin); if (url.origin === window.location.origin) destination = url.pathname + url.search + url.hash; } catch (_) {}
      }

      const error = this.querySelector('[data-b3-error]');
      error.hidden = true;
      this.busy = true;
      this.paint();
      // A wallet tap is going straight to checkout, so UpCart must not open its
      // drawer off the add below — it flashed open and delayed the handoff.
      // UpCart reads both flags off window on every add, and false means don't
      // open. Restored if the add fails, so the next normal add still opens it.
      const UPCART_FLAGS = ['upcartOpenOnAddToCartOverride', 'upcartShouldOpenOnAddToCartBackgroundNetworkCall'];
      const upcartBefore = UPCART_FLAGS.map(name => [name, Object.prototype.hasOwnProperty.call(window, name), window[name]]);
      if (express) for (const name of UPCART_FLAGS) window[name] = false;
      try {
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        const data = await response.json();
        if (!response.ok || data.status) {
          const message = typeof data.description === 'string' ? data.description
            : typeof data.message === 'string' ? data.message : this.labels.error;
          throw new Error(message);
        }
        this.dispatchEvent(new CustomEvent('b3-build:cart-added', { bubbles: true, detail: { items: data.items || [], destination } }));
        // The theme's drawer rebuilds itself and opens on this one event, so
        // the shopper stays on the page with their new cart in front of them.
        // Leaving instead sent them to whatever return_to said — which on this
        // form is /checkout, so a kit selection jumped straight past the cart.
        //
        // Only if there is no drawer to open do we fall back to navigating.
        // A wallet click goes on to checkout rather than stopping at the
        // drawer — that is what the shopper asked for by tapping it.
        if (express) {
          window.location.assign(this.dataset.checkoutUrl || '/checkout');
          return;
        }
        if (document.querySelector('#CartDrawer')) {
          this.busy = false;
          this.paint();
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { items: data.items || [] } }));
          return;
        }
        window.location.assign(destination);
      } catch (failure) {
        if (express) for (const [name, had, value] of upcartBefore) { if (had) window[name] = value; else delete window[name]; }
        this.uncertain = true;
        error.textContent = failure.message && failure.message !== this.labels.error ? `${failure.message} ${this.labels.error}` : this.labels.error;
        error.hidden = false;
        this.querySelector('[data-b3-cart-link]').hidden = false;
        this.busy = false;
        this.paint();
        error.scrollIntoView({ block: 'center', behavior: 'instant' });
      }
    }
  }
  customElements.define('puur-b3-build', PuurB3Build);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ps-build-dental-plan"] && !Shopify.designMode) return;
  try {
    (() => {
  const VIP_PROPERTY_NAME = 'Dental VIP Access';
  const VIP_PROPERTY_VALUE = 'Yes - Free 30 days, then $20/mo';
  if (customElements.get('puur-ps-build')) return;
  class PuurPSBuild extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const boot = () => {
        if (!this.querySelector('[data-labels]')) return;
        this.observer?.disconnect();
        this.init();
      };
      if (this.querySelector('[data-labels]')) boot();
      else {
        this.observer = new MutationObserver(boot);
        this.observer.observe(this, { childList: true, subtree: true });
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.formObserver?.disconnect();
      this.releaseNativeForm();
      this.swap?.remove();
      this.swap = null;
      clearTimeout(this.syncTimer);
      this.controller = null;
    }
    init() {
      this.labels = JSON.parse(this.querySelector('[data-labels]').dataset.config);
      this.money = new Intl.NumberFormat(this.labels.locale, { style: 'currency', currency: this.labels.currency });
      this.busy = false;
      this.uncertain = false;
      // Selection order, not DOM order, decides which kit the gallery shows:
      // picking a second kit should move the gallery to it rather than leave it
      // on whichever card happens to sit highest in the list.
      this.pickSeq = 0;
      this.cards = Array.from(this.querySelectorAll('[data-psb-card]')).map(el => ({
        el, kind: el.dataset.kind, config: JSON.parse(el.querySelector('[data-card-config]').dataset.config),
        variantSelect: el.querySelector('[data-variant]'), planSelect: el.querySelector('[data-plan]'),
        selected: ['system', 'starter'].includes(el.dataset.kind)
      }));
      // A card that is `locked` is settled somewhere else — the membership is
      // already held, or already its own line in the cart. It shows as taken,
      // and it is kept out of the total and out of the cart payload, because
      // charging or adding it again enrols one person twice.
      for (const card of this.cards) {
        if (card.kind === 'vip' && card.el.querySelector('[data-vip-enrolled]')) {
          card.locked = 'member';
          card.selected = true;
        }
      }
      for (const card of this.cards) this.refreshPlans(card, true);
      this.guardMembership();
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-select]');
        if (button && this.contains(button) && !this.busy) {
          const card = this.cards.find(c => c.el === button.closest('[data-psb-card]'));
          if (card && this.offer(card).valid) {
            card.selected = !card.selected;
            if (card.selected) card.pickedAt = ++this.pickSeq;
            this.paint();
          }
        }
      }, { signal: this.controller.signal });
      this.addEventListener('change', event => {
        const card = this.cards.find(c => c.el === event.target.closest('[data-psb-card]'));
        if (!card || this.busy) return;
        if (event.target.matches('[data-variant]')) this.refreshPlans(card);
        if (event.target.matches('[data-vip]')) card.selected = event.target.checked;
        this.paint();
      }, { signal: this.controller.signal });
      this.addEventListener('shopify:block:select', event => {
        const card = this.cards.find(c => c.el.dataset.blockId === event.detail.blockId);
        if (!card) return;
        if (card.el.tagName === 'DETAILS') card.el.open = true;
        const parent = card.el.closest('.psb-kits-step');
        if (parent) parent.open = true;
      }, { signal: this.controller.signal });
      this.mainProduct = this.closest('.product-section[data-section-type="product"]');
      if (this.mainProduct) {
        this.bindNativeForm();
        for (const type of ['click', 'submit']) {
          this.mainProduct.addEventListener(type, event => this.handleNativeEvent(event), { capture: true, signal: this.controller.signal });
        }
        this.mainProduct.addEventListener('change', event => {
          if (this.contains(event.target)) return;
          clearTimeout(this.syncTimer);
          this.syncTimer = setTimeout(() => this.syncMain(), 0);
        }, { signal: this.controller.signal });
        document.addEventListener('variant:change', event => {
          const belongs = this.mainProduct.contains(event.target) || String(event.detail?.sectionId) === this.mainProduct.dataset.sectionId;
          if (belongs) this.syncMain(event.detail?.variant?.id);
        }, { signal: this.controller.signal });
        this.bindGallery();
        // The theme rebuilds the slideshow when an image set switches variant
        // group, which takes the swap layer with it; rebind rather than leave a
        // detached node behind.
        this.formObserver = new MutationObserver(() => { this.bindGallery(); if (this.bindNativeForm()) this.syncMain(); });
        this.formObserver.observe(this.mainProduct, { childList: true, subtree: true });
        this.syncMain();
      }
      this.paint();
    }
    /* ------------------------------------------------------------------
       Gallery swap

       Selecting a kit puts that kit's photo in the main product gallery.

       It is drawn as a layer over the slideshow rather than pushed in as a
       real slide: the kit photos are theme files, not product media, so a
       slide would have no thumbnail to pair with and the theme drives the
       thumbs as Flickity's childNav — an unpaired cell puts the two out of
       step for every image after it. A layer needs nothing from Flickity and
       leaves the gallery exactly as it found it.

       Every node here is built in script, so the gallery snippet is untouched
       and a page without this builder is unaffected.
    ------------------------------------------------------------------ */
    /* ------------------------------------------------------------------
       Cart guard

       The membership can already be in the cart — put there by this page
       before a reload, or by the dialcare card on another page. Offering it
       again adds a second Recharge subscription billing one person for one
       plan, so the card is locked and shown as taken.

       Both membership products count, not just the one this page sells: a
       shopper can take the $0 Group 1 plan elsewhere and arrive here. Matched
       on product id rather than variant so a recreated variant does not
       quietly reopen the hole.

       If the cart cannot be read the opt-in is left usable. A shopper blocked
       from a membership they do not have is worse than the duplicate this
       guards against, which the cart and checkout can still catch.
    ------------------------------------------------------------------ */
    async guardMembership() {
      const card = this.cards.find(c => c.kind === 'vip');
      if (!card || card.locked) return;
      const ids = this.labels.membershipIds || [];
      if (!ids.length) return;
      let cart;
      try {
        const response = await fetch(`${this.dataset.cartUrl}.js`, {
          credentials: 'same-origin', headers: { Accept: 'application/json' }
        });
        if (!response.ok) return;
        cart = await response.json();
      } catch (_) { return; }
      const held = (cart.items || []).some(item => ids.some(id => String(item.product_id) === String(id)));
      if (!held) return;
      card.locked = 'cart';
      // Ticked, because it is true: the membership is in the cart and is being
      // bought. An empty greyed box beside "already in your cart" says the
      // opposite of the sentence next to it, and reads as unavailable rather
      // than secured.
      card.selected = true;
      const note = card.el.querySelector('[data-vip-held]');
      if (note) {
        const mark = document.createElement('span');
        mark.setAttribute('aria-hidden', 'true');
        mark.textContent = '\u2713';
        const text = document.createElement('span');
        text.textContent = 'Dental VIP Access is already in your cart — it will not be added twice.';
        note.replaceChildren(mark, text);
        note.hidden = false;
      }
      this.paint();
    }
    bindGallery() {
      if (this.swap && this.swap.isConnected) return;
      const group = this.mainProduct && this.mainProduct.querySelector('[data-product-single-media-group]');
      if (!group) return;
      // The layer is positioned against this box, which the theme leaves static.
      if (getComputedStyle(group).position === 'static') group.style.position = 'relative';

      const swap = document.createElement('div');
      swap.className = 'psb-gallery-swap';
      group.append(swap);

      this.gallery = group;
      this.swap = swap;

      // No caption bar: the design does not have one. Getting back to the
      // product photos is still a click on the image itself or on any
      // thumbnail, which sit outside this layer and are never covered.
      swap.addEventListener('click', () => this.dismissGallerySwap(), { signal: this.controller.signal });
      const thumbs = this.mainProduct.querySelector('[data-product-thumbs]');
      if (thumbs) thumbs.addEventListener('click', () => this.dismissGallerySwap(), { signal: this.controller.signal });
    }
    // Dismissal is remembered against the kit that was showing, so the gallery
    // stays put afterwards but a DIFFERENT kit still brings it back.
    dismissGallerySwap() {
      this.swapDismissedFor = this.swapShownFor;
      this.hideGallerySwap();
    }
    hideGallerySwap() {
      if (!this.swap) return;
      this.swap.classList.remove('psb-swap-in');
      this.swapShownFor = null;
    }
    paintGallery(selectedKits) {
      if (!this.swap) return;
      const featured = selectedKits.reduce(
        (best, card) => (!best || (card.pickedAt || 0) > (best.pickedAt || 0) ? card : best), null);
      if (!featured) {
        this.swapDismissedFor = null;
        this.hideGallerySwap();
        return;
      }
      const id = featured.el.dataset.blockId;
      if (id === this.swapDismissedFor) return;
      const template = featured.el.querySelector('[data-gallery]');
      if (!template) { this.hideGallerySwap(); return; }
      if (this.swapShownFor !== id) {
        for (const previous of Array.from(this.swap.querySelectorAll('img'))) previous.remove();
        const image = template.content.cloneNode(true);
        // Eager: it is about to be the largest thing on screen, and a lazy
        // image swapped in on click arrives blank.
        for (const img of image.querySelectorAll('img')) img.loading = 'eager';
        this.swap.prepend(image);
        this.swapShownFor = id;
      }
      this.swap.classList.add('psb-swap-in');
    }
    bindNativeForm() {
      const byId = document.getElementById(this.dataset.formId);
      const form = byId?.tagName === 'FORM' && this.mainProduct?.contains(byId) ? byId :
        this.mainProduct?.querySelector('form[action*="/cart/add"]');
      if (form === this.form && this.nativeButton?.isConnected) return false;
      this.releaseNativeForm();
      this.form = form || null;
      this.nativeButton = form?.querySelector('.payment-buttons button[name="add"][data-add-to-cart]') || null;
      if (!this.nativeButton) { this.form = null; return false; }
      this.nativeText = this.nativeButton.querySelector('[data-add-to-cart-text]') || this.nativeButton;
      this.originalNative = {
        text: this.nativeText.dataset.defaultText || this.nativeText.textContent,
        disabled: this.nativeButton.disabled,
        busy: this.nativeButton.getAttribute('aria-busy'),
        style: this.form.style.getPropertyValue('--psb-native-red')
      };
      this.form.classList.add('psb-native-form');
      this.form.style.setProperty('--psb-native-red', getComputedStyle(this).getPropertyValue('--psb-red').trim() || '#C8102E');
      this.nativeButton.setAttribute('data-psb-native-add', '');
      this.wallets = Array.from(form.querySelectorAll('.payment-buttons .shopify-payment-button'));
      for (const note of form.querySelectorAll('.psb-native-wallet-note')) note.remove();
      this.walletNote = document.createElement('p');
      this.walletNote.className = 'psb-native-wallet-note';
      this.walletNote.textContent = 'Use Add to cart for your selected kits or membership. Shop Pay is available at checkout.';
      this.walletNote.hidden = true;
      this.walletNote.setAttribute('role', 'status');
      form.querySelector('.payment-buttons').append(this.walletNote);
      return true;
    }
    releaseNativeForm() {
      if (this.nativeButton && this.originalNative) {
        this.nativeText.textContent = this.originalNative.text;
        this.nativeButton.disabled = this.originalNative.disabled;
        if (this.originalNative.busy === null) this.nativeButton.removeAttribute('aria-busy');
        else this.nativeButton.setAttribute('aria-busy', this.originalNative.busy);
        this.nativeButton.removeAttribute('data-psb-native-add');
        this.form.classList.remove('psb-native-form');
        if (this.originalNative.style) this.form.style.setProperty('--psb-native-red', this.originalNative.style);
        else this.form.style.removeProperty('--psb-native-red');
      }
      for (const wallet of this.wallets || []) wallet.removeAttribute('data-psb-wallet-hidden');
      this.walletNote?.remove();
      this.form = null;
      this.nativeButton = null;
      this.wallets = [];
    }
    nativeValues() {
      const value = name => this.form?.elements.namedItem(name)?.value || '';
      const quantity = Number(value('quantity') || 1);
      return { id: String(value('id')), quantity, planId: String(value('selling_plan')) };
    }
    // Something this page still has to ADD. A locked card is excluded: it is
    // either already held or already its own cart line, so there is nothing to
    // put in the cart and the theme's own add-to-cart is left to do its job.
    hasExtras() {
      return this.cards.some(card => (card.kind === 'kit' || card.kind === 'vip') && card.selected && !card.locked);
    }
    // Separate question, and the reason it is separate: an accelerated checkout
    // ignores the cart, so a membership sitting in it would be dropped on the
    // way to a wallet. The wallets come out for that even though there is
    // nothing left to add. An already-enrolled member has no such line and
    // keeps them.
    cartHoldsMembership() {
      return this.cards.some(card => card.locked === 'cart');
    }
    handleNativeEvent(event) {
      if (!this.form) return;
      // ---- accelerated checkout ----------------------------------------
      // Shop Pay, PayPal, Apple Pay and G Pay check out the FORM, not the cart,
      // and a dynamic checkout form carries exactly one variant. So a shopper
      // who picked a kit or the membership and then tapped a wallet bought the
      // flosser on its own and lost the rest.
      //
      // The wallet lives in a closed shadow root, so its own handler cannot be
      // reached — but the click is retargeted to the host on the way down, and
      // this listener is already on the capture phase above it. Stopping it
      // here runs before anything inside the shadow root sees it.
      //
      // What replaces it: put everything in the cart, then hand the shopper to
      // checkout, where the same wallets are offered against the full cart.
      // They lose one tap and keep the order they actually built.
      if (event.type === 'click') {
        const wallet = event.target.closest?.(
          '.shopify-payment-button, shopify-accelerated-checkout, shopify-accelerated-checkout-cart, shopify-buy-it-now-button');
        if (wallet && this.form.contains(wallet)) {
          // Nothing of ours to carry: let the wallet do its normal job.
          if (!this.hasExtras() && !this.cartHoldsMembership() && !this.busy && !this.uncertain) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          if (this.busy || this.uncertain || !this.form.reportValidity()) return;
          this.addToCart({ express: true });
          return;
        }
      }
      const button = event.target.closest?.('button[name="add"][data-add-to-cart]');
      if (event.type === 'click' && button !== this.nativeButton) return;
      if (event.type === 'submit' && event.target !== this.form) return;
      if (!this.hasExtras() && !this.busy && !this.uncertain) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.busy || this.uncertain || !this.form.reportValidity()) return;
      this.syncMain();
      this.addToCart();
    }
    paintNativeButton(valid, total) {
      if (!this.nativeButton) return;
      this.nativeButton.disabled = this.busy || this.uncertain || !valid;
      this.nativeText.textContent = this.busy ? this.labels.loading : valid ?
        `${this.labels.atc} — ${this.money.format(total / 100)}` : this.labels.unavailable;
      this.nativeButton.setAttribute('aria-busy', String(this.busy));
      // QA asked for the wallet to stay put when a kit is selected. It is a
      // setting rather than a straight flip, because an accelerated checkout
      // ignores the cart: a shopper who picks a kit and then taps Shop Pay buys
      // the flosser alone. Hiding it is the safe default; keeping it is the
      // merchant's call, and one toggle away either way.
      //
      // A membership already in the cart still hides it regardless — that line
      // exists and a wallet checkout would silently drop it.
      // Wallets no longer need hiding: a wallet click is intercepted above and
      // routed through the cart, so it can no longer lose a kit or the
      // membership. The setting stays for a merchant who wants them gone anyway.
      const noWallets = this.labels.hideWallets === true && (this.hasExtras() || this.cartHoldsMembership());
      for (const wallet of this.wallets) wallet.toggleAttribute('data-psb-wallet-hidden', noWallets || this.busy || this.uncertain);
      this.walletNote.hidden = !noWallets;
    }
    syncMain(id) {
      if (this.busy) return;
      const core = this.cards.find(c => c.kind === 'system' && String(c.config.productId) === this.dataset.productId);
      if (!core || core.config.defaultVariant) return;
      const value = String(id || this.nativeValues().id || '');
      if (core.config.variants.some(v => v.id === value) && core.variantSelect.value !== value) {
        core.variantSelect.value = value;
        this.refreshPlans(core);
      }
      this.paint();
    }
    refreshPlans(card, initial = false) {
      if (card.config.bundled) return;
      const variant = card.config.variants.find(v => v.id === card.variantSelect?.value);
      const previous = card.config.defaultPlan || (initial ? '' : card.planSelect.value);
      card.planSelect.replaceChildren();
      const mode = card.kind === 'vip' ? 'subscription' : 'one_time';
      const allowOneTime = mode !== 'subscription' && !card.config.requiresPlan;
      if (allowOneTime) card.planSelect.add(new Option(this.labels.oneTime, ''));
      if (mode !== 'one_time') {
        for (const plan of variant?.plans || []) {
          if (plan.recurring) card.planSelect.add(new Option(`${plan.name} — ${plan.money}`, plan.id));
        }
      }
      const options = Array.from(card.planSelect.options);
      const preferred = options.find(o => o.value === previous);
      if (preferred) card.planSelect.value = preferred.value;
      else if (card.config.defaultPlan && mode !== 'one_time') card.planSelect.selectedIndex = -1;
      card.el.querySelector('[data-plan-wrap]').hidden = true;
      card.variantSelect.hidden = card.config.variants.length <= 1;
      card.variantSelect.previousElementSibling.hidden = card.variantSelect.hidden;
    }
    offer(card) {
      if (card.config.bundled) return { valid: true, price: 0, bundled: true };
      const variant = card.config.variants.find(v => v.id === card.variantSelect?.value);
      const native = this.nativeValues();
      const planId = card.kind === 'system' ? native.planId : card.planSelect?.value;
      const plan = variant?.plans.find(p => p.id === planId && p.recurring);
      const mode = card.kind === 'vip' ? 'subscription' : 'one_time';
      const requiresPlan = card.config.requiresPlan || mode === 'subscription';
      const valid = Boolean(variant?.available && (card.kind !== 'system' || (variant.id === native.id && Number.isSafeInteger(native.quantity) && native.quantity > 0)) && (!requiresPlan || plan) && (!planId || plan) && (card.kind === 'system' || (card.planSelect.options.length && card.planSelect.selectedIndex >= 0)) && !card.config.invalidVariant);
      return { valid, variant, plan, price: plan ? plan.price : (variant?.price || 0) };
    }
    paint() {
      if (!this.cards) return;
      let total = 0;
      let valid = this.cards.some(c => c.kind === 'system');
      const selectedKits = [];
      const renewals = this.querySelector('[data-renewals]');
      renewals.replaceChildren();
      for (const card of this.cards) {
        const offer = this.offer(card);
        if (card.selected && !card.locked) {
          total += offer.price * (card.kind === 'system' ? this.nativeValues().quantity || 1 : 1);
          if (!offer.valid) valid = false;
        }
        // A locked card reads as taken whatever the variant says. Its price is
        // not in the total and it is not sold here, so a sold-out variant must
        // not blank out a membership the shopper already holds.
        const taken = card.locked ? true : card.selected && offer.valid;
        card.el.classList.toggle('psb-on', taken);
        if (card.kind !== 'kit') card.el.classList.toggle('psb-done', taken);
        card.el.querySelector('[data-card-check]')?.classList.toggle('psb-done', taken);
        const price = card.el.querySelector('[data-price]');
        price.classList.toggle('psb-free', offer.bundled || (offer.valid && offer.price === 0));
        price.textContent = offer.bundled ? card.config.includedLabel : offer.valid ? (offer.price === 0 && card.config.freeLabel ? card.config.freeLabel : offer.plan?.money || offer.variant.money) : this.labels.unavailable;
        const compare = card.el.querySelector('[data-compare]');
        compare.textContent = card.config.compareLabel || (offer.variant?.compare > offer.price ? offer.variant.compareMoney : '');
        compare.hidden = !compare.textContent;
        const missing = card.el.querySelector('[data-unavailable]');
        if (missing) missing.hidden = offer.valid;
        const disclosure = card.el.querySelector('[data-plan-disclosure]');
        let renewal = '';
        if (offer.plan) {
          renewal = card.config.renewal || offer.plan.name;
        }
        if (disclosure) { disclosure.textContent = renewal; disclosure.hidden = !renewal; }
        if (card.selected && renewal && !card.locked) {
          const p = document.createElement('p');
          const label = document.createElement('strong');
          label.textContent = 'Renews: ';
          p.append(label, `${card.config.title} — ${renewal}`);
          renewals.append(p);
        }
        // Step 1's refills and the Basic Starter ship with every order, so their
        // replenishment is stated whether or not anything else on the page
        // renews, and in card order. Neither has a selling plan of its own to
        // read a term from yet, so both lines are copy.
        if ((card.kind === 'system' || card.kind === 'starter') && card.config.renewsNote) {
          const p = document.createElement('p');
          const label = document.createElement('strong');
          label.textContent = 'Renews: ';
          p.append(label, card.config.renewsNote);
          renewals.append(p);
        }
        const select = card.el.querySelector('[data-select]');
        if (select) {
          select.disabled = this.busy || !this.form || !offer.valid;
          select.setAttribute('aria-pressed', String(card.selected));
          select.textContent = !offer.valid ? this.labels.unavailable : card.selected ? `✓ ${card.config.selectedLabel}` : this.labels.select;
          if (card.selected) selectedKits.push(card);
        }
        const vip = card.el.querySelector('[data-vip]');
        if (vip) {
          vip.disabled = this.busy || !this.form || !offer.valid || Boolean(card.locked);
          vip.checked = card.selected;
          card.el.querySelector('[data-vip-label]').textContent = card.selected ? `✓ ${card.config.selectedLabel}` : card.config.optIn;
          card.el.querySelector('[data-card-subtitle]').textContent = card.selected ? (card.config.selectedSubtitle || card.config.selectedLabel) : card.config.subtitle;
        }
        const options = card.el.querySelector('.psb-options');
        if (options && card.kind !== 'system') options.hidden = offer.valid && card.config.variants.length <= 1;
        if (card.variantSelect) card.variantSelect.disabled = this.busy;
        if (card.planSelect) card.planSelect.disabled = this.busy;
      }

      const kitStep = this.querySelector('.psb-kits-step');
      if (kitStep) {
        const kitTotal = selectedKits.reduce((sum, c) => sum + this.offer(c).price, 0);
        kitStep.classList.toggle('psb-done', Boolean(selectedKits.length));
        this.querySelector('[data-kit-check]').classList.toggle('psb-done', Boolean(selectedKits.length));
        // The summary names the picked kits and what they add. '[price]' in the
        // label is filled with the real kit total, so it can never disagree with
        // the pill beside it or with checkout.
        const kitMoney = this.money.format(kitTotal / 100);
        const addedLabel = this.labels.added.includes('[price]')
          ? this.labels.added.split('[price]').join(kitMoney)
          : `${this.labels.added} ${kitMoney}`;
        this.querySelector('[data-kit-state]').textContent = selectedKits.length ? `${selectedKits.map(c => c.config.title).join(', ')} — ${addedLabel}` : this.labels.optional;
        const compare = this.querySelector('[data-kit-compare]');
        const kitPrice = this.querySelector('[data-kit-total]');
        if (selectedKits.length) {
          const compareTotal = selectedKits.reduce((sum, card) => sum + (this.offer(card).variant?.compare || 0), 0);
          compare.hidden = compareTotal <= kitTotal;
          compare.textContent = this.money.format(compareTotal / 100);
          kitPrice.textContent = `+${this.money.format(kitTotal / 100)}`;
        } else {
          // Nothing picked yet, so the collapsed header shows what a kit costs.
          // Read from the real variants, never typed in, so it cannot disagree
          // with the add-to-cart total or with what checkout charges.
          const from = this.cards.filter(c => c.kind === 'kit').map(c => this.offer(c))
            .filter(o => o.valid).sort((a, b) => a.price - b.price)[0];
          const fromCompare = from?.variant?.compare || 0;
          compare.hidden = !from || fromCompare <= from.price;
          compare.textContent = from ? this.money.format(fromCompare / 100) : '';
          kitPrice.textContent = from ? this.money.format(from.price / 100) : '';
        }
        const preview = this.querySelector('[data-kit-preview]');
        preview.replaceChildren();
        for (const card of selectedKits) {
          const template = card.el.querySelector('[data-preview]');
          if (template) { const span = document.createElement('span'); span.className = 'psb-strip'; span.append(template.content.cloneNode(true)); preview.append(span); }
        }
      }
      if (selectedKits.length) {
        const p = document.createElement('p');
        const label = document.createElement('strong');
        label.textContent = 'One-time: ';
        p.append(label, `${selectedKits.map(card => card.config.title).join(', ')} — will not renew.`);
        renewals.append(p);
      }
      renewals.hidden = !renewals.childElementCount;
      this.paintGallery(selectedKits);
      this.total = total;
      this.valid = valid;
      this.querySelector('[data-total]').textContent = valid ? this.money.format(total / 100) : this.labels.unavailable;
      this.paintNativeButton(valid, total);
      this.dispatchEvent(new CustomEvent('ps-build:change', { bubbles: true, detail: {
        sectionId: this.dataset.sectionId, total, currency: this.labels.currency,
        kits: selectedKits.map(c => c.config.productId), vip: this.cards.some(c => c.kind === 'vip' && c.selected)
      } }));
    }
    async addToCart({ express = false } = {}) {
      if (this.busy || this.uncertain || !this.valid || !this.form) return;
      const formData = new FormData(this.form);
      const native = this.nativeValues();
      const core = this.cards.find(c => c.kind === 'system');
      const baseOffer = core && this.offer(core);
      if (!baseOffer?.valid || String(formData.get('id')) !== native.id) { this.paint(); return; }
      const base = { id: Number(native.id), quantity: native.quantity };
      const baseProperties = {};
      for (const [key, value] of formData.entries()) {
        const property = key.match(/^properties\[(.+)\]$/);
        if (property && typeof value === 'string') baseProperties[property[1]] = value;
      }
      if (Object.keys(baseProperties).length) base.properties = baseProperties;
      if (native.planId) base.selling_plan = Number(native.planId);
      const items = [base];
      for (const card of this.cards.filter(c => c.selected && !c.locked && (c.kind === 'kit' || c.kind === 'vip'))) {
        const offer = this.offer(card);
        if (!offer.valid) { this.paint(); return; }
        const item = { id: Number(offer.variant.id), quantity: 1 };
        if (offer.plan) item.selling_plan = Number(offer.plan.id);
        if (card.kind === 'vip') {
          // Same stamps as the dialcare card: the host product lets
          // dental-cart-guard remove the membership if the flosser leaves the
          // cart, and a Group 1 page declares its group or the member is
          // enrolled — and billed — as Group 2.
          item.properties = { [VIP_PROPERTY_NAME]: VIP_PROPERTY_VALUE };
          if (this.dataset.productId) item.properties._dental_host_product = String(this.dataset.productId);
          if (this.labels.dentalGroup) item.properties._dental_group = this.labels.dentalGroup;
        }
        const existing = items.find(line => line.id === item.id && line.selling_plan === item.selling_plan &&
          JSON.stringify(line.properties || {}) === JSON.stringify(item.properties || {}));
        if (existing) existing.quantity += 1;
        else items.push(item);
      }
      let destination = this.dataset.cartUrl;
      const returnTo = formData.get('return_to');
      if (typeof returnTo === 'string' && returnTo) {
        try { const url = new URL(returnTo, window.location.origin); if (url.origin === window.location.origin) destination = url.pathname + url.search + url.hash; } catch (_) {}
      }
      const error = this.querySelector('[data-error]');
      error.hidden = true;
      this.busy = true;
      this.paint();
      // A wallet tap is going straight to checkout, so UpCart must not open its
      // drawer off the add below — it flashed open and delayed the handoff.
      // UpCart reads both flags off window on every add, and false means don't
      // open. Restored if the add fails, so the next normal add still opens it.
      const UPCART_FLAGS = ['upcartOpenOnAddToCartOverride', 'upcartShouldOpenOnAddToCartBackgroundNetworkCall'];
      const upcartBefore = UPCART_FLAGS.map(name => [name, Object.prototype.hasOwnProperty.call(window, name), window[name]]);
      if (express) for (const name of UPCART_FLAGS) window[name] = false;
      try {
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        });
        const data = await response.json();
        if (!response.ok || data.status) {
          const message = typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : this.labels.error;
          throw new Error(message);
        }
        this.dispatchEvent(new CustomEvent('ps-build:cart-added', { bubbles: true, detail: { items: data.items || [], destination } }));
        // The theme's drawer rebuilds itself and opens on this one event, so
        // the shopper stays on the page with their new cart in front of them.
        // Leaving instead sent them to whatever return_to said — which on this
        // form is /checkout, so a kit selection jumped straight past the cart.
        //
        // Only if there is no drawer to open do we fall back to navigating.
        // A wallet click goes on to checkout rather than stopping at the
        // drawer — that is what the shopper asked for by tapping it.
        if (express) {
          window.location.assign(this.dataset.checkoutUrl || '/checkout');
          return;
        }
        if (document.querySelector('#CartDrawer')) {
          this.busy = false;
          this.paint();
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { items: data.items || [] } }));
          return;
        }
        window.location.assign(destination);
      } catch (failure) {
        if (express) for (const [name, had, value] of upcartBefore) { if (had) window[name] = value; else delete window[name]; }
        this.uncertain = true;
        error.textContent = failure.message && failure.message !== this.labels.error ? `${failure.message} ${this.labels.error}` : this.labels.error;
        error.hidden = false;
        this.querySelector('[data-cart-link]').hidden = false;
        this.busy = false;
        this.paint();
        error.scrollIntoView({ block: 'center', behavior: 'instant' });
      }
    }
  }
  customElements.define('puur-ps-build', PuurPSBuild);
})();
  } catch(e) { console.error(e); }
})();

})();
